//View Keys
export default {
  behavior_reportView: 'Report'
};
